import Clipboard from 'clipboard'
import { message } from 'ant-design-vue'
import store from '../store'

export function openWinWithATag(url) {
  if (!url) {
    return
  }

  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('rel', 'noopener noreferrer')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export function downloadWithATag(url, filename) {
  if (!url) {
    return
  }

  const a = document.createElement('a')
  a.setAttribute('href', url)
  if (filename) {
    a.setAttribute('download', filename)
  }
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export function copy(text, event) {
  function convertText(text) {
    if (!text) {
      return ''
    }
    if (text.startsWith('ssh://')) {
      const hostPort = text.substr(6).split(':') // trim 'ssh://'
      const ip = hostPort[0]
      const port = hostPort[1]

      return `ssh -p ${port} root@${ip}`
    } else if (text.startsWith('vnc://')) {
      return text.replace('vnc://', '')
    }

    return text
  }

  const clipboard = new Clipboard(event.currentTarget, {
    text: () => convertText(text)
  })
  clipboard.on('success', () => {
    message.success('复制成功')
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    message.error('复制失败')
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.onClick(event)
}

export function getFileName(filepath) {
  return filepath.replace(/^.*\/([^/]+)$/, '$1')
}

export function getFileExt(filepath) {
  return filepath.replace(/^.*\.(.*)$/, '$1').toLowerCase()
}

export async function downloadFsFile(token, filepath, filename, courseId) {
  if (!token.startsWith('Bearer')) {
    token = `Bearer%20${token}`
  }
  const fsUrl = await store.dispatch('course/getFsUrl', courseId)
  const url = `${fsUrl}/fs?path=${encodeURIComponent(
    filepath
  )}&Authorization=${token}`

  downloadWithATag(url, filename)
}

export function formatFileSize(size, digits = 1) {
  if (!size || size < 0) {
    return '0B'
  }

  const unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const index = Math.floor(Math.log2(size) / 10)
  return (size / Math.pow(2, index * 10)).toFixed(digits) + unit[index]
}
